import Response from "../../Data/Domain/Response";
import Project from "../../Projects/Domain/Project";
import { getOwnersByProject } from "./Owners.service";

export async function getOwnersByProjectRepository(id) {
  const data = await getOwnersByProject(id);
  return new Response(data, Project).getMultiple();
}
